import {Component, OnInit} from '@angular/core';
import {combineLatestAll, of} from 'rxjs';
import {PrlDashboardDataService} from '../../services/dashboard/prl-dashboard-data.service';
import {TopZoneMxObj} from 'mx-core';
import {PrlAccountDataService} from '../../services/account/prl-account-data.service';

@Component({
    selector: 'prl-dashboard',
    templateUrl: './prl-dashboard.component.html',
    standalone: false,
    styleUrls: ['./prl-dashboard.component.scss']
})
export class PrlDashboardComponent implements OnInit {
    topZones = new Array<TopZoneMxObj>();
    showMonthlyCommission: boolean = false;
    allowSubaffiliates: boolean = false;

    constructor(
        private readonly accountDataService: PrlAccountDataService,
        private readonly dashboardDataService: PrlDashboardDataService,
        private readonly monthlyCommissionDataService: PrlDashboardDataService
    ) {
    }

    ngOnInit(): void {
        of(
            this.monthlyCommissionDataService.isShowMonthlyCommission(),
            this.dashboardDataService.getTopZones(),
            this.accountDataService.isAllowSubaffiliates()
        )
            .pipe(combineLatestAll())
            .subscribe((response) => {
                this.showMonthlyCommission = response[0] as boolean;
                this.topZones = response[1] as Array<TopZoneMxObj>;
                this.allowSubaffiliates = response[2] as boolean;
            });
    }

}
